import type { Pair } from '../messages';

/**
 * Document metadata. `applyLocale()` writes these into the tags that ship statically in
 * index.html, so the served Russian default stays the crawler copy and the live tab follows
 * the chosen language.
 */
export const meta = {
  'meta.title': ['my-lib space — личная библиотека ссылок', 'my-lib space — a personal library of links'],
  'meta.description': [
    'my-lib space — личная библиотека ссылок: карточки собираются сами, подборки читаются как маршрут автора.',
    'my-lib space — a personal library of links: cards build themselves, collections read like an author’s route.',
  ],
  'meta.ogDescription': [
    'Ссылка превращается в карточку сама по Open Graph и JSON-LD, а подборка читается как маршрут автора: ссылки и комментарии в одном порядке.',
    'A link becomes a card on its own through Open Graph and JSON-LD, and a collection reads like an author’s route: links and comments in one order.',
  ],
  'meta.twitterDescription': [
    'Ссылка превращается в карточку сама, а подборка читается как маршрут автора.',
    'A link becomes a card on its own, and a collection reads like an author’s route.',
  ],
} satisfies Record<string, Pair>;
